<template>
  <!-- <PromoHeader ref="promoHeader" /> -->
  <MainNav ref="mainNav" @logo-loaded="onLogoLoaded" />
  <router-view></router-view>
</template>

<script>
import { ref, onMounted, onUpdated, onBeforeUnmount, provide } from "vue";
// import PromoHeader from "@/components/Header/PromoHeader.vue";
import MainNav from "@/components/Header/MainNav.vue";

export default {
  name: "App",
  components: {
    // PromoHeader,
    MainNav,
  },
  setup() {
    const promoHeader = ref(null);
    const mainNav = ref(null);
    const totalHeaderHeight = ref(0);

    const calculateHeaderHeight = () => {
      const promoHeaderHeight = promoHeader.value?.$el.offsetHeight || 0;
      const mainNavHeight = mainNav.value?.$el.offsetHeight || 0;
      totalHeaderHeight.value = promoHeaderHeight + mainNavHeight;
    };

    const onLogoLoaded = () => {
      calculateHeaderHeight();
    };

    onMounted(() => {
      calculateHeaderHeight(); // Initial calculation on mount
      window.addEventListener("resize", calculateHeaderHeight); // Add resize listener
    });

    onUpdated(calculateHeaderHeight); // Recalculate on component updates as well (optional, but good to keep)

    onBeforeUnmount(() => {
      window.removeEventListener("resize", calculateHeaderHeight); // Remove listener on unmount
    });

    provide("totalHeaderHeight", totalHeaderHeight);

    return {
      promoHeader,
      mainNav,
      onLogoLoaded,
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/main.scss";
</style>
